export default __webpack_public_path__ + "static/media/5.0a22e976.jpg";